import cn from "classnames";
import { useMemo, useState, useEffect } from "react";

import { useIntl } from "react-intl";
import { useForm, Controller } from "react-hook-form";
import { Button, Select, TextInput, Accordion } from "components";
import { MdFilterListAlt } from "react-icons/md";
import { useWindowSize } from "rooks";

import { useDoctorsFilters } from "./hooks/useDoctorsFilters";
import { TDoctorsFiltersFormValue } from "../Doctors.types";

import "./DoctorsFilters.scss";

interface DoctorsFiltersProps {
  className?: string;
  onChange?: (e: TDoctorsFiltersFormValue) => void;
}

export function DoctorsFilters({ className, onChange }: DoctorsFiltersProps) {
  const { formatMessage } = useIntl();

  const { watch, reset, control } = useForm({
    defaultValues: {
      speciality: null,
      branch: null,
      name: "",
      order: null,
      order_by: null
    }
  });

  const { innerWidth } = useWindowSize();

  const [isMobile, setIsMobile] = useState<boolean>(false);

  const { specialities, branches } = useDoctorsFilters();
  
  const orderOptions = [
    { label: "აღმავალი", value: "asc" },
    { label: "დაღმავალი", value: "desc" }
  ];

  const orderByOptions = [
    { label: "რეიტინგით", value: "rating" },
    { label: "შეფასებების რაოდენობით", value: "rating_quantity" },
    // { label: "თარიღით", value: "publish_date" }
  ];

  useEffect(() => {
    if (innerWidth && innerWidth <= 800) setIsMobile(true);
    else setIsMobile(false);
  }, [innerWidth]);

  watch((formValues) => {
    onChange?.(formValues);
  });

  const doctorsFiltersForm = useMemo(() => {
    return (
      <form>
        <div className="filters__inputs">
          <Controller
            name="name"
            control={control}
            render={({ field }) => {
              return (
                <TextInput
                  search
                  wrapperClassName="input"
                  placeholder={formatMessage({
                    id: "doctors.indetity.input-placeholder",
                    defaultMessage: "_indetity.input-placeholder_"
                  })}
                  startValue={field.value}
                  onChange={(e) => field.onChange(e.target.value)}
                />
              );
            }}
          />
          <Controller
            name="speciality"
            control={control}
            render={({ field }) => {
              return (
                <Select
                  placeholder={formatMessage({
                    id: "doctors.ocupation.select-placeholder",
                    defaultMessage: "_select-placeholder_"
                  })}
                  value={field.value}
                  className="input"
                  classNamePrefix="filter-input"
                  options={specialities}
                  onChange={(value) => field.onChange(value)}
                />
              );
            }}
          />
          <Controller
            name="branch"
            control={control}
            render={({ field }) => {
              return (
                <Select
                  placeholder={formatMessage({
                    id: "doctors.branch.select-placeholder",
                    defaultMessage: "_select-placeholder_"
                  })}
                  value={field.value}
                  className="input"
                  classNamePrefix="filter-input"
                  options={branches}
                  onChange={(value) => field.onChange(value)}
                />
              );
            }}
          />
          <Controller
            name="order"
            control={control}
            render={({ field }) => {
              return (
                <Select
                  placeholder={formatMessage({
                    id: "doctors.sort.select-placeholder",
                    defaultMessage: "_select-placeholder_"
                  })}
                  value={field.value}
                  className="input"
                  classNamePrefix="filter-input"
                  options={orderOptions}
                  onChange={(value) => {
                    field.onChange(value);
                  }}
                />
              );
            }}
          />
          {/* <Controller
            name="order_by"
            control={control}
            render={({ field }) => {
              return (
                <Select
                  placeholder={formatMessage({
                    id: "doctors.sortBy.select-placeholder",
                    defaultMessage: "_select-placeholder_"
                  })}
                  value={field.value}
                  className="input"
                  classNamePrefix="filter-input"
                  options={orderByOptions}
                  onChange={(value) => {
                    field.onChange(value);
                  }}
                />
              );
            }}
          /> */}
        </div>
        <div className="filters__buttons">
          <Button
            type="button"
            className="filters__buttons-clear"
            onClick={() => reset()}
          >
            {formatMessage({
              id: "doctors.filters.clear",
              defaultMessage: "_clear_"
            })}
          </Button>
        </div>
      </form>
    );
  }, [specialities, branches, formatMessage, reset, control]);

  return (
    <div
      className={cn(className, {
        ["filters-mobile"]: isMobile,
        ["filters-desktop"]: !isMobile
      })}
    >
      {!isMobile && doctorsFiltersForm}
      {isMobile && (
        <Accordion
          title={
            <>
              <MdFilterListAlt />
              <h5>
                {formatMessage({
                  id: "doctors.modal.filter.title",
                  defaultMessage: "_filter.title_"
                })}
              </h5>
            </>
          }
        >
          {doctorsFiltersForm}
        </Accordion>
      )}
    </div>
  );
}
